import { BasePath } from '@constants/Auth';
import DateFnsUtils from '@date-io/date-fns';
import { ThemeProvider } from '@material-ui/core';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { handleApiError, setBaseUrl, setTenantId } from '@services/http';
import { AuthProvider, AuthService } from '@swyft/auth';
import { ConfigureLogger, Log } from '@swyft/core';
import { setBaseUrl as setQuestionnaireBaseUrl, setTenantId as setQuestionnaireTenantId } from '@swyft/questionnaire';
import { BaseMuiTheme } from '@swyft/ui';
import { AppProvider } from '@utils/appState';
import { QueryClient, QueryClientProvider } from 'react-query';
import { runtimeConfig } from './config';
import { AppRoutes } from './routes';

setBaseUrl(runtimeConfig.api.baseUrl);
setTenantId(runtimeConfig.api.tenantId);
setQuestionnaireBaseUrl(runtimeConfig.api.baseUrl);
setQuestionnaireTenantId(runtimeConfig.api.tenantId);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 10_000,
      retry: false
    }
  }
});

ConfigureLogger(Log.ERROR, console);

const authService = new AuthService({
  authority: runtimeConfig.auth.authority,
  clientId: runtimeConfig.auth.clientId,
  basePath: BasePath,
  handleRedirectCallbackState: (path?: string) => window.location.replace(`${BasePath}${path || '/'}`)
});

function App(): JSX.Element {
  return (
    <ThemeProvider theme={BaseMuiTheme}>
      <AuthProvider authService={authService} handleApiError={handleApiError}>
        <QueryClientProvider client={queryClient}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <AppProvider>
              <AppRoutes />
            </AppProvider>
          </MuiPickersUtilsProvider>
        </QueryClientProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
